module.exports = __webpack_public_path__ + "static/media/prairie-dog.c29933c8.webp";